var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateReady)?_c('div',{attrs:{"id":"refresh"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("refresh.new_version"))+"\n    "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.$t("refresh.reload")))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }